import { z } from "zod";
import { duplicateSchema } from "./onboarding.js";
import { planViewSchema } from "./plans.js";

export const planResponseSchema = z.object({ plan: planViewSchema.nullable() });
export const duplicatesResponseSchema = z.object({ duplicates: z.array(duplicateSchema) });

export const profileCreatedSchema = z.object({ id: z.string() });
export const profileRevisionSchema = z.object({ revision: z.number() });
export const mergeReversedSchema = z.object({ state: z.string() });
export const trackingStartedSchema = z.object({ revision: z.number(), approved: z.array(z.string()) });
export const suggestionDecidedSchema = z.object({ source_id: z.string().nullable() });
export const discoveryStartedSchema = z.strictObject({ state: z.literal("queued") });
export const refreshDecidedSchema = z.object({ revision: z.number(), accepted: z.number(), rejected: z.number() });
export const profileReactivatedSchema = z.object({
  revision: z.number(),
  gaps: z.array(z.string()),
  plan_revision: z.string().nullable(),
});
export const draftDeletedSchema = z.object({ deleted: z.literal(true) });
export const profileSplitSchema = z.object({ merge_id: z.string(), profile_id: z.string(), state: z.string() });
export const mergeStartedSchema = z.object({ merge_id: z.string(), state: z.string() });
